import React from 'react';

export const TITLE_FILMS = [
  {
    textSize: '3.375rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Reel</span>,
  },
];

export const REEL_FILMS = [
  {
    textSize: '1rem',
    marginBottom: '0px',
    textMobile: '0.75rem',
    renderContent: () => (
      <span>
        *All material presented in this Producer reel is part of Jonathan
        Bouzali’s professional trajectory as Producer and Founder of KUTER
        FILMS. Each piece corresponds to projects in which he has directly
        participated in his role as Producer.
      </span>
    ),
  },
];
